import { ActiveFiltersKeysT } from '@/routes/projectStages/issues/lib/hooks/useActiveFilters.ts'
import { SetURLSearchParams } from 'react-router-dom'

export function setParam(
  key: ActiveFiltersKeysT,
  value: string,
  setSearchParams: SetURLSearchParams,
) {
  // changes the value of an existing param to new value or creates one if param with a given key
  // doesn't exist
  // rest of search params will remain the same

  setSearchParams(params => {
    const newParams = Object.fromEntries(params)
    newParams[key] = value
    return newParams
  })
}
